/**
 * api 주소정보
 */
export const uriConstants = {
  API_URI: process.env.REACT_APP_API_URL,
  HOME_URI: process.env.REACT_APP_HOME_URL,
  EDMS_URL: process.env.REACT_APP_EDMS_URL,
  // 공통코드 조회
  GET_COMMON_CODE: '/portal/common/code',

  // 고객지원
  GET_REFERENCE: '/portal/dat', //자료실
  GET_NOTICE: '/portal/notice', //공지사항
  GET_FAQ: '/portal/faq', //자주묻는질문
  QUESTION: '/portal/qna', //묻고답하기
  QUESTION_PWD: '/portal/qna/passwd', //묻고답하기 비밀번호확인

  // 사업자관리
  GET_GROUP_INFO: '/portal/group/search-info', //사업자 정보 조회
  SET_GROUP_INFO: '/portal/group/update-info', //사업자 정보 변경

  // 이용자 관리
  GET_INVITE_LIST: '/portal/invite/list', // 초대목록조회
  GET_INVITE_LIST2: '/portal/invite/list2', // 초대목록조회2
  SET_INVITE_USER: '/portal/invite/user', // 초대저장 및 수정(취소포함)
  SET_INVITE_DROP: '/portal/invite/drop', // 이용자 탈퇴
  SET_INVITE_MAIL: '/portal/invite/send', // 초대 이메일 전송
  GET_PERMISSION: '/portal/user/auth-member', // 위임 회원 조회
  LIST_DELEGATE_USER: '/portal/user/auth-list', //위임대상 회원 조회
  DELEGATE_PERMISSION: '/portal/user/auth-manager', //권한 위임 신청 및 취소
  QR_PDF_VERIFICATION: '/portal/file/qr/qrScan', //위변조확인

  // 로그인
  SIGN_IN: '/portal/signin', //로그인
  SIGN_IN_CORP: '/portal/signinCorp', //로그인법인
  FIND_ID: '/portal/user/find-id-', //아이디 찾기
  FIND_PW: '/portal/user/find-pw-', //비밀번호 찾기
  PUSH_INFO: '/portal/push/device', //PUS토큰 등록
  CHECK_PWD: '/portal/user/checkPw',

  // 회원가입
  REGIS_MANAGER: '/portal/user/manager', //관리자 회원 가입
  REGIS_SIMPLE_MANABER: '/portal/user/simpleManager', //관리자 회원 가입 - 기관코드 추가
  REGIS_USER: '/portal/user', //일반 회원 가입
  CHECK_ID: '/portal/user/exists-id', //아이디 중복체크
  CHECK_GROUP: '/portal/user/exists-group', //사업자 아이디 중복체크
  GET_INVITE_INFO: '/portal/user/invt-id', //초대정보 조회
  GET_UTH_INFO: '/portal/user/uth-info', //UTH 가입정보 조회
  GET_PCC_PARAM: '/portal/cert/pcc-param', //PCC 본인인증 파라미터 조회
  GET_PCC_RST: '/portal/cert/pcc-result', //PCC 본인인증 결과값 조회
  GET_PCC_PARAM_V4: '/portal/cert/pcc-param-v4', //PCC 본인인증 V4 파라미터 조회
  GET_PCC_RST_V4: '/portal/cert/pcc-result-v4', //PCC 본인인증 V4 결과값 조회(crypto_token_id 기준)
  CHECK_MOBILE: '/portal/user/exists-mobile', // MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크
  DUPLE_BIZNO: '/portal/user/exists-bizno', // 사업자번호 중복체크

  // 회원정보
  GET_USERINFO: '/portal/user', //회원정보 조회 및 변경
  GET_DEVICE_ID: '/portal/user/deviceId', // 디바이스 ID 가져오기
  SET_USERINFO: '/portal/user/retire', //회원 탈퇴
  SET_PASSWORD: '/portal/user/pass', //비밀번호 변경
  SET_INACTIVE: '/portal/user/active', // 휴면설정
  UPDATE_EWALLET_ID: '/portal/user/update-ewallet-id', //전자지갑 주소 발급 업데이트
  DELETE_EWALLET_ID: '/portal/user/delete-ewallet-id', //전자지갑 주소 삭제 업데이트
  UPDATE_PASSWD_MODDT: '/portal/user/updatePasswdModDt', //비밀번호 수정일자 업데이트

  // 모바일
  MOBILE_ALARM_COUNT: '/portal/push/count',
  MOBILE_ALARM_LIST: '/portal/push',
  MOBILE_ALARM_DELETE_ALL: '/portal/push/delete-all',

  // SERVICE
  CHECK_UTH_GET_DOCNUM: '/portal/issuedcrt/check-user', //UTH 사용자 확인 및 문서번호 채번
  ISSUE_ACTION_STEP: '/portal/issuedcrt/', //구매확인서 등록관련 액션
  ISSUE_SUBMIT: '/portal/issuedcrt/send', //구매확인서 발급신청 요청
  ISSUE_DELETE: '/portal/issuedcrt/temp-all/del', //구매확인서 임시저장정보 삭제
  GET_ISSUE: '/portal/issuedcrt/temp/', //구매확인서 호출
  GET_REAPP_ISSUE: '/portal/issuedcrt/reapp/', //구매확인서 호출 재신청

  CONFIRMATION_CALL: '/portal/confirmation', //구매확인서 호출
  GET_INBOX_LIST: '/portal/confirmation', // 증명서 수신함
  GET_SENT_LIST: '/portal/confirmation/sendbox/list', // 증명서 송신함
  WITHDRAW_SENT: '/portal/confirmation/sendbox/withdraw/', //구매확인서 반려
  GET_CERTMNG_LIST: '/portal/certMng', // 증명서 신청 목록
  GET_BUNDLE_LIST: '/portal/pacKage', // 꾸러미 신청 목록
  GET_CERTISSUE_LIST: '/portal/issuedcrt/list', // 증명서 신청현황 목록
  GET_READING_LIST: '/portal/confirmation/reading/', // 증명서 1회 열람

  GET_RECENT_LIST: '/portal/confirmation/recent', // 최근 보낸 주소 조회
  GET_WALLET_LIST: '/portal/confirmation/wallet', // 전자지갑 주소 조회

  // 증명서 상세조회
  GET_PRCL_INFO: '/portal/confirmation/pcrl',
  GET_CRTF_INFO: '/portal/confirmation/crtf',
  GET_INBOX_INFO: '/portal/confirmation/detail',
  GET_SENT_INFO: '/portal/confirmation/send-detail',
  GET_CERTISSUE_INFO: '/portal/issuedcrt/detail', // 증명서 신청현황 상세
  GET_CERTMNG_INFO: '/portal/certMng/detail', // 증명서 신청 상세
  GET_BUNDLE_INFO: '/portal/pacKage/detail', // 꾸러미 신청 상세
  SUB_SENT_DOC_PDF: '/portal/file/getpdf',

  // 증명서 삭제
  SET_INBOX_INFO: '/portal/confirmation/modify/del',
  // 증명서 제출
  SUBMIT_CERTIFICATE: '/portal/confirmation/submit',
  // 증명서 제출
  UPLOAD_CERTIFICATE: '/portal/confirmation/upload',
  // 증명서 반려
  REJECT_CERTIFICATE: '/portal/confirmation/reject',
  // 증명서 수취완료
  RECEIVE_CERTIFICATE: '/portal/confirmation/receive',
  // 증명서 1회열람
  READING_CERTIFICATE: '/portal/confirmation/reading',
  // 증명서 1회열람확인
  READING_COMPLETION: '/portal/confirmation/reading/completion',
  // 첨부파일 다운로드 -> edms 읽음 여부 update
  EFDOC_DOWNLOAD: '/portal/confirmation/efDocDownLoad',
  // 첨부파일 출력
  EFDOC_PRINT: '/portal/confirmation/efDocPrint',
  // 첨부파일 다운로드
  EFDOC_DOWN: '/portal/confirmation/efDocDown',

  // 증명서 진본검증
  VERIFY_CERTIFACATE: '/portal/confirmation/verify',
  VERIFY_CERTIFACATE_NOT_MEMBER: '/portal/confirmation/verify/notmember',

  // 증명서 PDF BASE64STRING 조회
  GET_PDF_INFO: '/portal/pdf',

  // 증명서 첨부파일 다운로드
  GET_FILE: '/portal/file',

  //간편로그인
  PASS_SIGN_IN: '/portal/passSignin', //간편로그인
  //핀번호 재설정
  PIN_RESET: '/portal/pinReset', //핀번호 재설정
  //핀번호 설정여부 확인
  PIN_EMPTY_YN: '/portal/pinEmptyYn', //핀번호 설정여부 확인

  // 이용약관 조회
  GET_TERMS: '/portal/terms',
  // 개인정보처리방침 조회
  GET_PRIVACY: '/portal/privacy',
  // 개인정보 수집 및 이용내역(필수)
  GET_ESSENTIAL_PRIVACY: '/portal/essentialPrivacy',
  // 개인정보 수집 및 이용동의(선택)
  GET_OPTIONAL_PRIVACY: '/portal/optionalPrivacy',

  //SNS로그인 등록
  ADD_KAKAO_LOGIN: '/portal/oauth/callback/kakao',
  M_KAKAO_LOGIN: '/portal/oauth/addKakaoMobile',
  ADD_NAVER_LOGIN: '/portal/oauth/callback/naver',
  M_NAVER_LOGIN: '/portal/oauth/addNaverMobile',
  GET_SNS_USERINFO: '/portal/change/login',
  //SNS로그인 해제
  DIS_SNSLOGIN: '/portal/snslogin/delete',

  //공동인증서 저장
  ADD_CRTFCT_INFO: '/portal/crtfct/save',
  //공동인증서 삭제
  DEL_CRTFCT_INFO: '/portal/crtfct/delete',
  //공동인증서 로그인
  LOGIN_CRTFCT_INFO: '/portal/crtfct/login',
  LOGIN_CRTFCT_INFO_IOS: '/portal/crtfct/loginIos',
  //공동인증서 등록여부
  CHCEK_CRTFCT_INFO: '/portal/crtfct/info',
  //디지털원패스
  DIGT_ONEPASS_INFO: '/portal/oauth/dgtOnePass',
  ADD_ONEPASS_CHECK: '/oauth/callback/onepass',
  ADD_ONEPASS_LOGIN: '/portal/oauth/onepass/login',
  DIS_ONEPASS: '/oauth/callback/onepassDis',
  //qr생성
  QR_IMG_MAKE: '/portal/qr/qrImgMake',
  QR_LOGIN: '/portal/qr/loginCheck',
  //pin 번호로그인
  SIMPLE_LOGIN: '/portal/oauth/simple/login',
  //uuid 확인
  CHECK_UUID: '/portal/checkUUid',
  //공인전자문서
  GET_EFDOC_LIST: '/portal/efdoc',

  //EDMS 관련 URL
  EDMS_AUTH_TOKEN: '/auth/issue-token', // EDMS 시스템 인증
  EDMS_FILE_DOWNLOAD: '/documents/contents/download', // EDMS 시스템 파일 다운로드
  EDMS_LOGIN_ID: 'portal',
  EDMS_PASSWORD: '238325d916c4c24713d7e4bf6abb75648a2f32c8ad3b4b5ae3d2ec6f049fcadb',

  //주문서 조회
  ISSUED_ORDER_INFO: '/portal/issuedcrt/issuedCrtOrder',
  ISSUED_ORDER_RESULT: '/portal/issuedcrt/issuedCrtOrderResult',
  ISSUED_CANCEL_RESULT: '/portal/issuedcrt/issuedCrtCancelResult',

  // 정부전자문서지갑 - 개인 전자문서지갑 주소 확인
  VERIFY_INDI_ECDW: '/portal/egov/verifyIndiECDW',
  // 정부전자문서지갑 - 지갑화면 URL 요청
  GET_SCREEN_URL: '/portal/egov/ScreenURLRequest',
  // 정부전자문서지갑 - 개인 전자문서지갑 주소 발급
  ISSUE_INDI_ECDW: '/portal/egov/issueIndiECDW',
  // 개인 전자문서지갑 팝업함 조회
  INQUIRE_INDI_ECDW_POPUP_LIST: '/portal/egov/inquireIndiECDWPopupList',
  // 개인 전자문서지갑 주소 정보 변경
  CHANGE_INDI_ECDW_INFO: '/portal/egov/changeIndiECDWInfo',
  // 약관동의 내용 조회
  INQUIRE_INDI_STIP_AGREE: '/portal/egov/inquireIndiStipAgree',

  /** 커스텀 정부전자문서지갑 */
  // 정부전자문서지갑 - 증명서 신청 문서종류코드 목록 조회
  GET_APLY_SUPPORT_LIST: '/portal/gov/ECDApplySupportListInquire',
  // 정부전자문서지갑 - 증명서 신청 목록 조회
  GET_APLY_LIST_INQUIRE: '/portal/gov/ECDApplyListInquire',
  // 전자증명서 신청 자격 확인
  ECD_APPLY_QF_VERIFY: '/portal/gov/ECDApplyQFVerify',
  // 전자증명서 신청
  ECD_APPLY: '/portal/gov/ECDApply',

  // 회원앱정보 추가, 업데이트
  UPDATE_PTL_MEMBER_APP: '/portal/appMainUpdate',
  UPDATE_PTL_ALMPUSH_YN: '/portal/appAlmPushYn',
  GET_PTL_MEMBER_APP: '/portal/getAppMain',
  GET_PUSH_LIST: '/portal/pushList',

  INSERT_DEVICE_ID: '/portal/appAccess', // 디바이스 아이디 없으면 insert
  ISSUE_PDF_NEW: '/portal/tedas/etis/pcrl/testxml', //구매확인서 PDF생성

  // 성적서 일괄다운로드
  CHECKED_EFDOC_DOWNLOAD: '/portal/confirmation/checkedEfDocDownloads',

  GET_CHEMP_INBOX_LIST: '/portal/confirmation/chemp',
  GET_CHEMP_OUTBOX_LIST: '/portal/confirmation/chemp/sendbox'
}
